import axios from 'axios';
import { curriculumUrl } from '@/foundations/helpers/router';

export const curriculumApi = {
  getCurriculumByCountry(country) {
    return axios.get(curriculumUrl(`curriculum/country/${country}`)).then((response) => response);
  },

  getGoalsByResourceId(resourceId) {
    return axios.get(curriculumUrl(`${resourceId}`)).then((response) => response);
  },
};
